// pages/AgencyRegister.jsx
import React, { useState } from "react";
// import axios from "axios";
import axios from "../context/axios";

import Swal from "sweetalert2";
import backgroundImage from "../assets/images/bg.jpg";

const AgencyRegister = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    mobile: "",
    password: "",
    agencyName: "",
  });

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await axios.post("/register-agency", formData);
      // Swal.fire("Agency Registered Successfully!", "Pending admin approval.", "success");
      Swal.fire(
        "Agency Registered Successfully!",
        "Your registration has been received and is currently under review by our team. You will receive a confirmation email once your account is approved.",
        "success"
      );
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Registration Error",
        text: err.response?.data || "Registration Failed",
      });    }
  };

  return (
    <div  style={{
      backgroundImage: `url(${backgroundImage})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
    }} className="min-h-screen flex items-center justify-center p-6">
      <div className="bg-white p-10 rounded-xl shadow-xl w-full max-w-lg">
        <h2 className="text-4xl font-extrabold mb-8 text-center text-blue-700">
          Join as an Agency
        </h2>
        <p className="text-gray-600 mb-6 text-center text-sm">
          Start your business with us! Register your agency and get approved by admin.
        </p>
        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Full Name</label>
            <input
              type="text"
              name="fullName"
              placeholder="Full Name"
              onChange={handleChange}
              className="w-full border border-gray-300 rounded px-4 py-3 focus:ring-2 focus:ring-blue-400 focus:outline-none"
              required
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Business Name</label>
            <input
              type="text"
              name="agencyName"
              placeholder="Business Name"
              onChange={handleChange}
              className="w-full border border-gray-300 rounded px-4 py-3 focus:ring-2 focus:ring-blue-400 focus:outline-none"
              required
            />
          </div>
         
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
            <input
              type="email"
              name="email"
              placeholder="Email"
              onChange={handleChange}
              className="w-full border border-gray-300 rounded px-4 py-3 focus:ring-2 focus:ring-blue-400 focus:outline-none"
              required
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Mobile Number</label>
            <input
              type="text"
              name="mobile"
              placeholder="Mobile Number"
              onChange={handleChange}
              className="w-full border border-gray-300 rounded px-4 py-3 focus:ring-2 focus:ring-blue-400 focus:outline-none"
              required
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Password</label>
            <input
              type="password"
              name="password"
              placeholder="Password"
              onChange={handleChange}
              className="w-full border border-gray-300 rounded px-4 py-3 focus:ring-2 focus:ring-blue-400 focus:outline-none"
              required
            />
          </div>
          <button
            type="submit"
            className="w-full bg-blue-600 text-white py-3 rounded font-bold hover:bg-blue-700 transition"
          >
            Register Agency
          </button>
        </form>
      </div>
    </div>
  );
};

export default AgencyRegister;
